'use strict';

var simpleListCtrl = ['$state', '$scope', '$uibModal', function ($state, $scope, $uibModal) {
    var _this = this;

    try {
        _this.parsedField = JSON.parse(_this.field);
    } catch (error) {
        console.log(error);
    }

    _this.viewList = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'directives/simpleListDirective.html',
            controller: ['items', 'field', 'gridConfiguration', function (items, field, gridConfiguration) {

                items = items.map(function (item) {
                    return {
                        payload: item
                    };
                });

                var columnDefs = [];
                field.nodes.forEach(function (field) {
                    var tempObject = {
                        headerName: field.name || field.label,
                        field: 'payload.' + field.id + '.value',
                    };

                    if (field.type === 'number') {
                        tempObject.filter = 'number';
                        tempObject.cellRenderer  = gridConfiguration.numberRenderer;
                        tempObject.formData = field;
                        tempObject.cellClass = 'my-right-aligned-cell';
                    }
                    else if (field.type === 'text') {
                        tempObject.filter = 'text';
                    }
                    else if (field.type === 'date') {
                        tempObject.cellRenderer = gridConfiguration.dateRenderer;
                        tempObject.valueGetter = gridConfiguration.dateGetter;
                        tempObject.filter = gridConfiguration.dateFilter;
                        tempObject.field = field.id;
                    }
                    else if (field.type === 'time') {
                        tempObject.cellRenderer = gridConfiguration.timeRenderer;
                        tempObject.valueGetter = gridConfiguration.timeGetter;
                        tempObject.filter = gridConfiguration.timeFilter;
                        tempObject.field = field.id;
                    }
                    else if (field.type === 'timestamp') {
                        tempObject.cellRenderer = gridConfiguration.timestampRenderer;
                        tempObject.suppressMenu = true;
                        tempObject.field = field.id;
                        tempObject.valueGetter = gridConfiguration.payloadGetter;
                    }
                    else if (field.type === 'geo') {
                        tempObject.valueGetter = gridConfiguration.geoGetter;
                        tempObject.cellRenderer = gridConfiguration.geoRenderer;
                        tempObject.filter = 'text';
                        tempObject.field = field.id;
                    }
                    else if (field.type === 'select' || field.type === 'multiple') {
                        tempObject.valueGetter = gridConfiguration.multipleGetter;
                    }
                    else if (field.type === 'checkbox') {
                        tempObject.cellRenderer = gridConfiguration.checkboxRenderer;
                    }
                    if (field.type === 'docs') {
                        tempObject.cellRenderer = gridConfiguration.docsRenderer;
                        tempObject.valueGetter = gridConfiguration.photosGetter;
                        tempObject.field = field.id;
                        tempObject.suppressSorting = true;
                        tempObject.suppressMenu = true;
                    }   
                    else if (field.type === 'photo') {
                        tempObject.cellRenderer = gridConfiguration.photosRenderer;
                        tempObject.valueGetter = gridConfiguration.photosGetter;
                        tempObject.field = field.id;
                        tempObject.suppressMenu = true;
                    }else if (field.type === 'sign') {
                        tempObject.cellRenderer = gridConfiguration.signRenderer;
                        tempObject.suppressMenu = true;
                        tempObject.field = field.id;
                        tempObject.valueGetter = gridConfiguration.signGetter;
                    }
                    if (field.type === 'group') {
                        field.nodes.forEach(function (node) {
                            var tempObject = {
                                headerName: node.name || node.label,
                                field: node.id,
                                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' },
                                valueGetter: gridConfiguration.payloadGetter
                            };
    
                            if (node.type === 'title') {
                                return;
                            }
                            if (node.type === 'populate') {
                                return;
                            }
                            if (node.type === 'group') {
                                return;
                            }
                            if (node.type === 'number') {
                                tempObject.filter = 'number';
                                tempObject.cellRenderer = gridConfiguration.numberRenderer;
                                tempObject.formData = node;
                                tempObject.cellClass = 'my-right-aligned-cell';
                            }
                            if (node.type === 'formula') {
                                tempObject.filter = 'number';
                                tempObject.valueGetter = gridConfiguration.formulaGetter;
                                tempObject.formData = node;
                                tempObject.cellClass = 'my-right-aligned-cell';
                            }
                            if (node.type === 'text') {
                                tempObject.filter = 'text';
                            }
                            if (node.type === 'qr') {
                                tempObject.filter = 'text';
                            }
                            if (node.type === 'sign') {
                                tempObject.cellRenderer = gridConfiguration.signRenderer;
                                tempObject.suppressMenu = true;
                                tempObject.suppressSorting = true;
                                tempObject.field = node.id;
                                tempObject.valueGetter = gridConfiguration.signGetter;
                            }
                            if (node.type === 'geo') {
                                tempObject.cellRenderer = gridConfiguration.geoRenderer;
                                tempObject.valueGetter = gridConfiguration.geoGetter;
                                tempObject.node = node.id;
                                tempObject.suppressMenu = true;
                                tempObject.suppressSorting = true;
                            }
                            if (node.type === 'date') {
                                tempObject.cellRenderer = gridConfiguration.dateRenderer;
                                tempObject.filter = gridConfiguration.dateFilter;
                            }
                            if (node.type === 'time') {
                                tempObject.cellRenderer = gridConfiguration.timeRenderer;
                                tempObject.filter = undefined;
                                tempObject.suppressMenu = true;
    
                            }
                            if (node.type === 'timestamp') {
                                tempObject.cellRenderer = gridConfiguration.timestampRenderer;
                                tempObject.suppressMenu = true;
                            }
                            if (node.type === 'checkbox') {
                                tempObject.filter = "set";
                                tempObject.filterParams["values"] = [true, false];
                                tempObject.cellRenderer = gridConfiguration.checkboxRenderer;
                            }
                            if (field.type === 'docs') {
                                tempObject.cellRenderer = gridConfiguration.docsRenderer;
                                tempObject.valueGetter = gridConfiguration.photosGetter;
                                tempObject.field = node.id;
                                tempObject.suppressSorting = true;
                                tempObject.suppressMenu = true;
                            }
                            if (node.type === 'photo') {
                                tempObject.cellRenderer = gridConfiguration.photosRenderer;
                                tempObject.valueGetter = gridConfiguration.photosGetter;
                                tempObject.field = node.id;
                                tempObject.suppressMenu = true;
                                tempObject.suppressSorting = true;
                            }
                            if (node.type === 'select' || node.type === 'multiple') {
                                tempObject.valueGetter = gridConfiguration.multipleGetter;
                                tempObject.field = node.id;
                                //tempObject.suppressMenu = true;
                                tempObject.formData = node;
                                if (node.templateData.options && node.templateData.options.length > 0) {
                                    const filterValues = node.templateData.options.map(function (opt) {
                                        const s = String(opt);
                                        const idx = s.indexOf("|");
                                        return idx >= 0 ? s.substring(idx + 1) : s;
                                    });
                                    tempObject.filter = 'set';
                                    tempObject.filterParams = { cellHeight: 20, apply: true, newRowsAction: 'keep', values: filterValues }
                                }
                            }
                            columnDefs.push(tempObject);
                        });
                        return;
                    }

                    columnDefs.push(tempObject)
                });

                this.gridOptions = {
                    columnDefs: columnDefs,
                    rowData: items,
                    rowHeight: 40,
                    rowSelection: 'multiple',
                    enableSorting: true,
                    enableFilter: true,
                    enableColResize: true,
                    angularCompileRows: true,
                    angularCompileFilters: true,
                    angularCompileHeaders: true,
                    onGridReady: function (grid) {
                        grid.api.setHeaderHeight(40);

                    },
                    localeText: gridConfiguration.localeText
                };
            }],
            controllerAs: 'modal',
            size: 'lg',
            resolve: {
                items: function () {
                    return _this.data.payload[_this.parsedField.field].value;
                },
                field: function () {
                    return _this.parsedField.formData;
                }
            },
            windowClass: 'dialog',
            bindToController: true
        });

        modalInstance.result.then(function (selectedItem) {
            _this.selected = selectedItem;
        }, function () {

        });
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '@',
            data: '='
        },
        controller: simpleListCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        template: '<a ng-click="ctrl.viewList(); $event.stopPropagation()">{{ctrl.data.payload[ctrl.parsedField.field].value.length}} registros</a>'
    };
};
